export default __webpack_public_path__ + "static/mendix-e61eefab4e17eb9633afc2171979010f.png";